<template>
  <div class="container-out">
    <div class="search-box">
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAxFJREFUSA21lrFrU0Ecx/teXoiDg1AoWGhDSLIKwVZciiI4qEO7u9XFqZtjMVIEwc0/wK27BatDQcRJtCB0taFNCxYKgmsgbfx8z/c7Lq9p2uThweV397vv7/u9+929u0QTQ0qv1yu1Wq17QBapc9RpfJNRFP2m/Yu6Td2oVquf8HVoX1iiQQhIE4SWGWvSvj4IE/oQOxIW4be0u+FYtn1GEKHZ09PTdwAbWfAl+j/iOF5C+OA8bBwOIDbPir7j82LM+JD+K4gWisXidK1WK8mqL386bjQNxYvHHFnrV6iVCUydSkEdyFaZ7RvsufsDXvu8gl0jrqRY8MfU+UErdSsEnCiNJqaAJEnusprXw8RS8o5wwitOPvGkfIn6YXGCzPAJTktjp1AoLFYqla8h8KK28IoDZ9lowLucjYuZjdLw3AaY5eqoYharOMVbH6tT7tJsvmh3d/cBzg9yAD4k73WszdJwl7YSYGU/sTMp50NS/tEIlFKlwRVA63nERKJ48fxjdL+eXz0J6gZxhaO+ae08NsPj+cUpwWkjZ9Nb1s5jMzyeX5w6NJNGXi6XdUfmLiFPyC/imJx7kXa77cXzqIY8Ib8T5Ee3visnJydVa+exGR7PL07toZ4YV7gdHlk7j83weH5xSnDDyFn+Y3Le96Ha2GWt4sUT4D2/fDEfuh7PI3UAz/DRrqg9blG8eBQvXvGHXDo0ulWa5gS8tre3d9v6o1jFEf8yiGmm/N7lnidACVfcN7zuAgd0POoFLrFut7sFx1Wxw7lTr9dvwtX3D0B7qKV3uR2WJJSCpwj+zCSeETh0TzUuHPgvxDoxccA3sb+/7/vyqfgHWB3yrxf/PdUeYU3mkP66rivdIPqo9Z3p6Os0Mq6D5vZMHGFhbJuY+5VK5Y/5+wTlRHQWorH+0yC8o5Vhb3iBjKhLqQ3KcqoOeE5uMbunVHd6w/FBbeGE156xoju0/beH+BzZ2GKPryn2zApDQsBj/S8VuUQkZnyaBJNZGCpo4HHsANEXZKD53wQ1yUB0U2LjTHzkGESvhEF/AaxVjC9ddpiYAAAAAElFTkSuQmCC" alt="">
      <input
        type="text"
        placeholder="搜索"
        v-model="searchText"
        @input="handleSearchCity"
      />
    </div>
    <div class="select-list" v-show="searchText">
      <p
        v-for="(cityItem, index) in selectList"
        :key="index"
        @click="confirmCity(cityItem, 'normal')"
      >
        {{cityItem.cityName}}
      </p>
      <p class="selectListEmpty" v-if="selectList.length === 0">未匹配到城市</p>
    </div>

    <div v-show="!searchText">
      <div class="city-current" v-if="cityInfo.cityName">
        <span class="desc">
            <i class="icon-location"></i>
            <span>当前城市</span>
          </span>
        <span class="city">{{cityInfo.cityName}}</span>
      </div>

      <div class="city-hot" v-if="hotCityList.length">
        <div class="title">热门城市</div>
        <ul class="hot-list">
          <li
            class="hot-item"
            v-for="(item, index) in hotCityList"
            :key="index"
            @click="confirmCity(item, 'hot')"
          >
            <span>{{item.cityName}}</span>
          </li>
        </ul>
      </div>

      <div class="city-block" v-if="cityList.length">
        <div class="alpha-block" v-for="(item, index) in cityList" :key="index">
          <div class="alpha" :ref="item.groupName">{{item.groupName}}</div>
          <ul class="city-list" v-for="(cityItem, cityIndex) in item.data" :key="cityIndex">
            <li class="city-item" @click="confirmCity(cityItem, 'normal')">{{cityItem.cityName}}</li>
          </ul>
        </div>
      </div>

      <div class="alphabet-block">
        <ul class="alpha-list">
          <li
            class="alpha-item"
            v-for="(item, index) in cityList"
            :key="index"
            @click="goAnchorAlpha(item.groupName)"
          >{{item.groupName}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import store from '../store'
import Fetoast from '../components/toast'
import loading from '../components/fullLoading/index.js'
import { queryCityList } from '../api/service'
import { sendPointFn } from '../utils/utils'
export default {
  name: 'City',
  data () {
    return {
      cityInfo: { // 选中的城市信息
        cityCode: '',
        cityName: ''
      },
      hotCityList: [], // 热门城市列表
      cityList: [], // 字母划分城市列表
      searchText: '', // 搜索输入值
      selectList: [] // 搜索备选列表
    }
  },
  computed: {
    searchList: function () { // 搜索列表 将各字母中的城市合成一个方便搜索
      if (this.cityList.length) {
        let list = []
        this.cityList.forEach((item, index) => {
          if (item.data.length) {
            item.data.forEach((jtem) => {
              list.push(jtem)
            })
          }
        })
        return list
      } else {
        return []
      }
    }
  },
  created () {},
  mounted () {
    this.pageInit()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'index') { // 去首页 将选中的城市存入sessionStorage
      const cityInfoStr = JSON.stringify(this.cityInfo)
      sessionStorage.setItem('cityInfo', cityInfoStr)
    }
    next()
  },
  methods: {
    pageInit () { // 页面初始化
      this.handleSessionStorage()
      this.getStoreInfo()
    },

    handleSessionStorage () { // 解析当前选中的城市
      const cityInfo = JSON.parse(sessionStorage.getItem('beforeCityInfo'))
      if (cityInfo) {
        this.cityInfo = cityInfo
      }
    },

    getStoreInfo () { // 获取store里城市列表
      const rawCityInfo = this.$store.state.rawCityInfo
      if (rawCityInfo.cityList && this.hotCityList) { // 有数据 不重复请求
        this.hotCityList = rawCityInfo.hotCityList
        this.cityList = rawCityInfo.cityList
      } else { // 无数据 重新请求
        this.doQueryCityList()
      }
    },

    async doQueryCityList () { // 查询城市列表
      loading()
      let res = {}
      try {
        res = await queryCityList({ biz: 'trafficHome' })
      } catch (err) {
        loading.close()
        Fetoast('网络繁忙，请稍后重试！')
        return false
      }
      if (res.code === 'F_000000') {
        this.$store.commit('SET_RAW_CITYINFO', res.data) // store存储城市列表
        this.hotCityList = res.data.hotCityList
        this.cityList = res.data.cityList
      } else {
        Fetoast(res.msg || '网络繁忙，请稍后重试！')
      }
      loading.close()
    },

    confirmCity (data, moduleId) { // 点击切换城市
      this.cityInfo = data
      this.$router.back()
      this.sendPoint(data.cityCode, moduleId)
    },

    handleSearchCity () { // 搜索城市
      this.selectList = []
      let searchText = this.searchText.trim()
      if (searchText) {
        this.searchList.forEach((item, index) => {
          if (item.cityName.indexOf(searchText) > -1) {
            this.selectList.push(item)
          }
        })
      }
    },

    goAnchorAlpha (alpha) { // 锚点跳转
      const anchor = this.$refs[alpha]
      const target = anchor[0].offsetTop
      let doc = document.documentElement || document.body
      doc.scrollTop = target
    },

    sendPoint (clickId, moduleId) { // 发送埋点数据
      const pageId = 'city'
      clickId = clickId || 'default'
      moduleId = moduleId || 'default'
      sendPointFn(pageId, moduleId, clickId)
    }
  }
}
</script>

<style lang='scss' scoped>
$r: 100;
.container-out{
  width: 100vw;
  min-height: 100vh;
  background: white;
  padding-bottom: 50rem/$r;
  font-size: 28rem/$r;
  color: #333;
}
.fullLoading{
  width: 100vw;
  height: 100vh;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.5);
  z-index: 10;
  ::v-deep .van-loading{
    display: inline-block;
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
  }
}

// 搜索栏及城市选择
.search-box {
  width: 690rem/$r;
  margin: 20rem/$r auto 0;
  padding: 0 0 0 20rem/$r;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 30rem/$r;
  img {
    flex: 0 0 auto;
    width: 28rem/$r;
    height: 28rem/$r;
  }
  input {
    flex: 0 0 auto;
    width: 100%;
    padding: 10rem/$r 0 10rem/$r 20rem/$r;
    font-size: 28rem/$r;
    line-height: 20rem/$r;
    border: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none;
    background-color: transparent;
    &::placeholder {
      font-size: 28rem/$r;
      line-height: 30rem/$r;
    }
  }
}
.select-list {
  margin: 40rem/$r auto 0;
  width: 100%;
  p {
    position: relative;
    margin: 30rem/$r auto 0;
    padding: 0 0 15rem/$r 50rem/$r;
    font-size: 30rem/$r;
    color: #5d5d5d;
    &::after {
      content: "";
      margin: auto;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 660rem/$r;
      height: 1px;
      background-color: #ededed;
    }
  }
  .selectListEmpty {
    margin: 100rem/$r auto 0;
    padding: 0;
    text-align: center;
    color: #afafaf;
    &::after {
      display: none;
    }
  }
}
// 当前城市行
.city-current{
  padding: 0 50rem/$r 0 30rem/$r;
  height: 90rem/$r;
  line-height: 90rem/$r;
  border-bottom: 1px solid #f7f7f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .desc{
    margin-right: 20rem/$r;
    .icon-location{
      display: inline-block;
      width: 23rem/$r;
      height: 28rem/$r;
      background-image: url('//storage.360buyimg.com/fe-traffic/images/icon_location_black.png');
      background-size: 100% 100%;
      margin-right: 6rem/$r;
      position: relative;
      top: 3rem/$r;
    }
  }
  .city{
    text-decoration: underline;
  }
}
// 热门城市
.city-hot{
  padding: 0 30rem/$r;
  .title{
    height: 60rem/$r;
    line-height: 60rem/$r;
    font-size: 24rem/$r;
    color: #999;
  }
  .hot-list{
    font-size: 0;
    .hot-item{
      display: inline-block;
      position: relative;
      min-width: 140rem/$r;
      height: 56rem/$r;
      border-radius: 4rem/$r;
      margin-right: 20rem/$r;
      margin-bottom: 20rem/$r;
      background-color: #f5f5f5;
      font-size: 28rem/$r;
      color: #333;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      span{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
// 城市列表样式
.city-block{
  padding: 0 30rem/$r;
  .alpha-block{
    margin-top: 20rem/$r;
    .alpha{
      font-size: 24rem/$r;
      color: #999;
      height: 60rem/$r;
      line-height: 60rem/$r;
    }
    .city-list{
      .city-item{
        font-size: 28rem/$r;
        color: #333;
        height: 60rem/$r;
        line-height: 60rem/$r;
      }
    }
  }
}
// 右侧字母列表
.alphabet-block{
  height: 100vh;
  position: fixed;
  right: 20rem/$r;
  top: 0;
  display: flex;
  align-items: center;
  .alpha-list{
    width: 16rem/$r;
    .alpha-item{
      font-size: 18rem/$r;
      color: #333;
      padding: 3rem/$r;
    }
  }
}
</style>
